/**
 * Transforms pipe-separated values back to comma-separated values for display
 * @param value - The input string with pipe-separated values
 * @returns The transformed string with comma-separated values for user display
 */
export const transformPipesToCommas = (value: string): string => {
  if (!value) return value;

  return value.replace(/\|/g, ', ');
};
